exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-286772cc] .jumbo-modal-content{height:100%;background:#fcfdff!important;top:0!important;position:fixed!important}[data-v-286772cc] .modal-body{height:inherit;overflow:auto}.main-content-holder[data-v-286772cc]{overflow:scroll;padding:30px 0}", ""]);

// exports
